<script setup lang="ts">
interface SpotlightVideo {
  id: string
  url: string
  title: string
  description: string
  width?: number
  height?: number
  speaker?: string
}

interface SpotlightSection {
  videos: SpotlightVideo[]
}

defineProps<{
  spotlight: SpotlightSection
}>()
</script>

<template>
  <div class="py-12">
    <div class="max-w-7xl mx-auto">
      <!-- Videos Grid -->
      <div class="space-y-12">
        <div
          v-for="(video, index) in spotlight.videos"
          :key="index"
          class="flex flex-col lg:flex-row justify-start items-center gap-8"
          
        >
          <!-- Description -->
          <div class="w-full lg:flex-1 flex flex-col gap-4">
            <div>
                <h3 class="section-title">
                {{ video.title }}
                </h3>
                <div class="flex flex-wrap items-center gap-4">
                    <span class="speaker-info leading-tight">by {{ video.speaker }}</span>
                </div>
            </div>
            <p class="text-base leading-relaxed video-description">
              {{ video.description }}
            </p>
          </div>

          <!-- Video Player -->
          <div class="w-full lg:flex-1 flex flex-col items-center gap-4">
            <VimeoPlayer
              :config="{
                url: video.url,
                autoplay: false,
                controls: true,
                responsive: true,
                muted: false,
                title: false,
                byline: false,
                portrait: false,
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
h3.section-title {
  margin-bottom: 0.5rem;
  color: var(--p-text-color);
}

.speaker-info {
  color: var(--p-text-color-secondary);
}

.video-description {
  color: var(--p-text-color);
}
</style>    